<template>
  <div class="onboarding_comp auth-input-page">
    <div class="auth-input-page__group">
      <label class="auth-label-input">Choose platform</label>
      <v-menu
        bottom
        left
        offset-y
        :nudge-top="-5"
        :nudge-left="0"
        class="social-type-menu"
        content-class="social-menu__content"
      >
        <v-select
          :placeholder="socialChannel ? socialChannel.title : 'Select'"
          class="social-types-selector py-0"
          :class="{ _filled: socialChannel }"
          single-line
          hide-details
          slot="activator"
        ></v-select>

        <div
          v-for="(channel, i) in socialChannels"
          :key="i"
          @click="selectedChannel(channel)"
          class="channel-info"
          :class="[`${channel.id}-menu`]"
        >
          <div class="_title">{{ channel.title }}</div>
          <div class="_tags">
            {{ channel.tags }}
          </div>
        </div>
      </v-menu>
    </div>
    <div class="auth-input-page__group mt-1">
      <label class="auth-label-input">Username</label>
      <input v-model="socialUsername" type="text" />
    </div>

    <div
      :class="{
        'display-flex align-center gap-8 justify-space-between':
          $vuetify.breakpoint.width <= 1280,
      }"
    >
      <v-btn
        v-if="$vuetify.breakpoint.width <= 1280"
        class="back-button"
        @click="$emit('actionPrevStage')"
      >
        Back
      </v-btn>
      <v-btn
        :class="{
          _disabled: !validated('skipToast'),
          'auth-bg-disabled': checkDataEmpty,
          'auth-bg-active': !checkDataEmpty,
        }"
        class="auth-button"
        @click="handleNextStage()"
      >
        Next
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      isLoading: false,
      socialChannel: "",
      socialUsername: "@",
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      getSocialChannel: (state) => state.app.onboarding.social_provider,
      getSocialUsername: (state) => state.app.onboarding.social_user_name,
    }),
    socialChannels() {
      return [
        {
          title: "Instagram",
          id: "instagram",
        },
        {
          title: "Tik Tok",
          id: "tiktok",
        },
        {
          title: "Facebook",
          id: "facebook",
        },
        {
          title: "Twitter",
          id: "twitter",
        },
      ];
    },
    checkDataEmpty() {
      return this.socialChannel == "" || this.socialUsername == "@";
    },
  },
  watch: {
    socialUsername(val) {
      if (val.length < 2) {
        this.socialUsername = "@";
      }
    },
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    ...mapMutations({
      updateOnboarding: "app/updateOnboarding",
    }),
    validated(toastStatus) {
      const skipToast = toastStatus === "skipToast";

      const { socialChannel, socialUsername } = this;
      const valSocialUsername = socialUsername.length > 1;
      const toValidate = [socialChannel, valSocialUsername];

      const errors = [
        "Please choose a social channel",
        "Please enter a valid social handle",
      ];

      const isValid = toValidate.every((item, index) => {
        if (!skipToast && !item) {
          this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });
      return isValid;
    },
    selectedChannel(channel) {
      this.socialChannel = channel;
    },
    async handleNextStage() {
      this.handleClick();
      if (this.validated()) {
        const data = {
          social_provider: this.socialChannel.title,
          social_user_name: this.socialUsername,
        };
        this.updateOnboarding(data);
        let user_params = this.$store.state.app.onboarding;
        let formData = new FormData();

        formData.append("user[email]", user_params.email);
        formData.append("user[password]", user_params.password);
        formData.append("user[username]", user_params.username);
        formData.append("user[display_name]", user_params.fullName);
        formData.append("user[avatar]", user_params.avatar);
        formData.append("user[first_name]", user_params.first_name);
        formData.append("user[last_name]", user_params.last_name);
        formData.append("user[country]", user_params.country);
        formData.append("user[city]", user_params.city);
        formData.append("user[age_group]", user_params.age_group);
        formData.append("user[social_provider]", user_params.social_provider);
        formData.append("user[social_user_id]", user_params.social_user_name);
        formData.append("user[user_type]", user_params.user_type);
        formData.append("user[initial_signup_type]", user_params.user_type);

        if (user_params.accountCategory === "listener") {
          await AuthService.registerAsListener(formData)
            .then((response) => {
              this.updateOnboarding(data);
              this.gotoNextStage(this.current + 1);
            })
            .catch((e) => {
              this.$store.dispatch("error/showErrorToast", e.body.errors);
            });
        } else {
          await AuthService.registerAsArtist(formData)
            .then((response) => {
              this.gotoNextStage(this.current + 1);
            })
            .catch((e) => {
              this.$store.dispatch("error/showErrorToast", e.body.errors);
            });
        }
      }
    },
    handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
    handleClick() {
      if (this.validated()) {
        this.isLoading = true;
        this.$store
          .dispatch("error/showLoadingActivity", true)

          .catch((e) => {
            this.$store.dispatch("error/showErrorToast", e.body.errors);
          });
      }
    },
  },
  created() {
    this.socialChannel = this.getSocialChannel;
    this.social_user_name = this.getsocial_user_name;
  },
};
</script>

<style lang="scss" src="../../../../../static/styles/onboarding.scss"></style>

<style lang="scss" scoped>
.auth-input-page {
  &__group {
    display: flex;
    flex-direction: column;
    width: 354px;
  }
}
.auth-button {
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.back-button {
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 18.68px;
  text-align: center;
  background: #0000000d;
  height: 50px;
  border-radius: 56px;
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .auth-button {
    height: 50px !important;
    border-radius: 56px;
    font-size: 18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// getVerified.vue?687de0fd